import { sheetToJson } from '@/Libs/Sheets';
import mapper from './Mapper';

class Context {
  constructor(data, strategy) {
    this.data = data;
    this.strategy = strategy;
  }

  executeStrategy() {
    const json = sheetToJson({ ...this.data });
    const result = this.strategy(json);
    return result;
  }
}

function executeQunarStrategy(data) {
  return mapper.qunar(data, this.data.platform);
}
function executeMTTicketStrategy(data) {
  return mapper.mtticket(data, this.data.platform);
}
function executeCtripStrategy(data) {
  return mapper.ctrip(data, this.data.platform);
}
function executeCtripHuoDongStrategy(data) {
  return mapper.ctripHuodong(data, this.data.platform);
}

export default (data) => {
  let context = null;
  switch (data.platform.toLowerCase()) {
    case '37':
      context = new Context({ ...data, 'range': {} }, executeQunarStrategy);
      break;
    case '12':
      context = new Context({ ...data, 'range': {} }, executeCtripStrategy);
      break;
    case '13':
      context = new Context({ ...data, 'range': { '活动': { 'start': 5 } } }, executeCtripHuoDongStrategy);
      break;
    case '31':
      context = new Context({ ...data, 'range': {} }, executeMTTicketStrategy);
      break;
    default:
      return '';
  }
  const r = context.executeStrategy();
  return r;
};
